export const CBDS_NOT_AVAILABLE_ADULT_DELIVERY_MODE = 'notAvailableAdultDeliveryMode';
export const CBDS_MODIFICATION_STRATEGY_DISALLOWS_CART_OPERATIONS = 'modificationStrategyDisallowsCartOperations';
export const CBDS_NOT_AVAILABLE_ONLINE = 'notAvailableOnline';
export const CBDS_UNDECIDABLE = 'undecidable';
export const CBDS_UNAVAILABLE = 'unavailable';
export const CBDS_NOT_AVAILABLE_DURING_ORDER_MODIFICATION = 'notAvailableDuringOrderModification';
export const CBDS_NOT_AVAILABLE_OFFLINE_PRODUCT = 'notAvailableOfflineProduct';
